import { patchState, signalStoreFeature, type, withMethods } from "@ngrx/signals";
import { IAuthenticationState, initialAuthenticationState } from "./auth.state";
import { AuthToken } from "../../models/auth/auth-token.model";
import { decryptFromStorage, encryptToStorage } from "../../utils/storage-encryption.util";
import { isAccessTokenValid } from "../../utils/auth-token.util";

export const AUTH_TOKEN_STORAGE_KEY = 'caremo_auth_token';

export const withAuthenticationStateMethods = signalStoreFeature(
    { state: type<IAuthenticationState>() },
    withMethods((store) => ({
        storeAuthToken: (authToken: AuthToken) => {
            localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, encryptToStorage(authToken));
            patchState(store, { authToken, isAuthenticated: true, loading: false, error: null });
        },
        clearAuth: () => {
            localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
            patchState(store, initialAuthenticationState);
        },
        rehydrateAuthFromStorage: (): boolean => {
            const raw = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
            if (!raw) return false;

            const authToken = decryptFromStorage<AuthToken>(raw);
            if (!authToken?.accessToken || !isAccessTokenValid(authToken.accessToken)) {
                localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
                return false;
            }

            patchState(store, { authToken, isAuthenticated: true, loading: false, error: null });
            return true;
        },
    }))
);
